import { render, staticRenderFns } from "./uiPreload.vue?vue&type=template&id=0059b736&scoped=true"
var script = {}
import style0 from "./uiPreload.vue?vue&type=style&index=0&id=0059b736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059b736",
  null
  
)

export default component.exports